import { Component, Input, OnInit ,Inject} from '@angular/core';
import { ActividadModel } from 'src/app/model/PlanGestionConvivencia.model';
import { EstrategiaPgcComponent } from '../../components/estrategia-pgc/estrategia-pgc.component';

@Component({
  selector: 'app-actividad-pgc',
  templateUrl: './actividad-pgc.component.html',
  styleUrls: ['./actividad-pgc.component.css']
})
export class ActividadPgcComponent implements OnInit {

  @Input() actividad : ActividadModel;
  @Input() index : number;
  @Input() readonly : boolean;

  public isCollapsed = true;
  fechaValida : boolean = false;
  fechaClass : string = "input-fecha";
  startDate: Date;
  fechaInicio : any;
  fechaFin : any;

  constructor(@Inject(EstrategiaPgcComponent) private parent: EstrategiaPgcComponent) { }

  ngOnInit(): void {
    this.cargaInicial();
  }

  cargaInicial(){
    var fechaInicioMedicion =  this.actividad.fechaDesde ? new Date(this.actividad.fechaDesde) : null;
    var fechaFinMedicion =  this.actividad.fechaHasta ? new Date(this.actividad.fechaHasta) : null;
    if (fechaFinMedicion != null && fechaInicioMedicion != null) {
      
      this.fechaInicio  = {"day": fechaInicioMedicion.getDate(), "month": fechaInicioMedicion.getMonth() + 1, "year": fechaInicioMedicion.getFullYear()};

      this.fechaFin  = {"year": fechaFinMedicion.getFullYear(),"month": fechaFinMedicion.getMonth() + 1, "day": fechaFinMedicion.getDate()};
      this.validarFechas();
    }
  }

  change(){
    //this.parent.cambios = true;
    this.validarFechas();
  }

  clearDateInicio(){
    this.actividad.fechaDesde = null;
    this.fechaInicio = "";
  }

  clearDateFin(){
    this.actividad.fechaHasta = null;
    this.fechaFin = "";
  }

  validarFechas(){
    this.fechaClass = "input-fecha-error";
    this.fechaValida = false;
    if( this.fechaInicio != undefined && this.fechaFin != undefined  && this.fechaInicio != null && this.fechaFin != null){

      var fechaInicioMedicion = new Date(this.fechaInicio.year, this.fechaInicio.month -1, this.fechaInicio.day);
      var fechaFinMedicion = new Date(this.fechaFin.year, this.fechaFin.month -1 , this.fechaFin.day);

      this.actividad.fechaDesde = fechaInicioMedicion;
      this.actividad.fechaHasta = fechaFinMedicion;

      if (fechaFinMedicion.getTime() - fechaInicioMedicion.getTime() >= 0) {
      //if (fechaFinMedicion.valueOf() >= fechaInicioMedicion.valueOf()) {
        this.fechaValida = true;
        this.fechaClass = "input-fecha";
      } else {
        this.fechaClass = "input-fecha-error";
        this.fechaValida = false;
      }


    if(this.fechaValida){
        if(this.fechaInicio.year == 2026 && this.fechaFin.year == 2026){
          this.fechaValida = true;
          this.fechaClass = "input-fecha";
        } else {
          this.fechaClass = "input-fecha-error";
          this.fechaValida = false;
        }
    }

    } else {
      this.fechaClass =  "input-fecha-error";
      this.fechaValida = false;
    }
  }

  eliminarActividad( eliminar :number){
      this.parent.estrategia.actividades.splice(eliminar,1)
  }
  
}
